import { memo } from 'react';
import { connect } from 'react-redux';
import { Badge } from 'shards-react';

const FilterIndicator = ({ isFiltered, totalFilteredDocs }) => {
	if (!isFiltered) return null;

	return (
		<Badge tag='small' theme='danger' className='mr-2'>
			{`Die Dokumente wurden gefiltert! Anzahl: ${totalFilteredDocs}`}
		</Badge>
	);
};

const mapStateToProps = ({ filterByName, filterByEnvelopeName, totalFilteredDocs, filterByReference}) => {
	const isFiltered = (filterByName || filterByEnvelopeName || filterByReference) && typeof totalFilteredDocs === 'number';

	return {
		isFiltered,
		totalFilteredDocs,
	};
};

export default connect(mapStateToProps)(memo(FilterIndicator));
